module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Ge-Hc-Ic-Ja.d1f9e26f.png";